'use client';

import Image from "next/image";

type Card = {
  icon: string;
  description: string;
};

type GrayCardGridSectionProps = {
  cards: Card[];
  columns?: number;
  add_background?: boolean;
};

export function GrayCardGridSection({ cards, columns = 3, add_background = false }: GrayCardGridSectionProps) {
  const gridColsClass = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-4',
  }[columns] || 'grid-cols-1 md:grid-cols-3';

  const content = (
    <div className={`grid gap-6 ${gridColsClass}`}>
      {cards.map((card, i) => (
        <div
          key={i}
          className="bg-gray-100 rounded-xl p-6 flex flex-col"
        >
          {card.icon && (
            <Image
              src={`${card.icon}`}
              alt="card icon"
              width={100}
              height={100}
              className="mb-4"
            />
          )}
          <p className="text-gray-700">{card.description}</p>
        </div>
      ))}
    </div>
  );

  if (add_background) {
    return (
      <section className="w-screen relative left-1/2 right-1/2 -mx-[50vw] bg-gradient-to-b from-[rgba(237,237,249,0)] to-[#DEE5E8] my-8 py-8">
        <div className="bg-[url('/images/left-corner-supergrafis.png')] bg-no-repeat bg-left-bottom bg-[length:300px]">
          <div className="container max-w-7xl mx-auto items-start gap-8 flex">
            <div className="flex-1 min-w-0 px-10">
              {content}
            </div>
            <div className="w-80 flex-shrink-0 lg:block"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className="container mx-auto max-w-7xl px-10">
      {content}
    </div>
  );
}
